import { LogOut } from 'lucide-react';
import { useAuth } from '../../context/AuthContext';

const Header = () => {
    const { currentUser, logout } = useAuth();
    return (
        <header className="fixed top-0 left-0 right-0 h-16 bg-white/80 backdrop-blur-xl border-b border-gray-200/60 px-4 sm:px-6 flex items-center justify-between z-50">
            <div className="flex items-center gap-3">
                <a href="/dashboard" className="flex items-center"><img src="/nhclogo.png" alt="National HealthClaim" className="h-8 w-auto" /></a>
                <div className="h-6 w-[1px] bg-gray-300 mx-1" />
                <span className="text-sm font-medium text-gray-500 tracking-wide uppercase hidden sm:block">Sales Portal</span>
            </div>
            <div className="flex items-center gap-3">
                {currentUser && <span className="text-sm text-gray-600 font-medium">{currentUser.username}</span>}
                <button onClick={logout} className="inline-flex items-center gap-1.5 px-3 py-2 text-gray-500 hover:text-gray-900 text-sm font-medium transition-colors">
                    <LogOut className="w-4 h-4" /><span>Logout</span>
                </button>
            </div>
        </header>
    );
};

export default Header;
